import React from 'react';

import { get } from 'lodash';
import { connect, useSelector } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import { InternalButtonBar } from '../../../layout/components';
import { Box, Button, InfoLabel } from '../../../../common/components';
import TransferBrokerButton from '../TransferBrokerButton/TransferBrokerButton';
import { actions } from '../../redux/brokerActions';
import { brokerStatuses } from '../../../../schemas/broker';
import displayName from '../../../../helpers/displayName';
import displayAddress from '../../../../helpers/displayAddress';
import getIncludedResource from '../../../../helpers/getIncludedResource';
import InfoButton from '../../../../common/components/InfoButton/InfoButton';

const BrokerShow = ({
  resource,
  onDeactivateBroker,
  onReactivateBroker,
  onActivateBroker,
}) => {
  const { isActivating, isDeactivating, isReactivating } = useSelector(
    (state) => state.broker,
  );
  const status = resource?.data?.attributes?.status;

  const deactivateBroker = () => {
    return onDeactivateBroker(resource.data.id);
  };

  const reactivateBroker = () => {
    return onReactivateBroker(resource.data.id);
  };

  const activateBroker = () => {
    return onActivateBroker(resource.data.id);
  };
  const buttons = () => {
    const resourceAttributes = resource.data.attributes;
    const brokerType = get(resourceAttributes, 'broker_type', 'broker');
    const brokerId = resource.data.id;

    const organisation = getIncludedResource(
      resource.data,
      resource.included,
      'organisation',
    );

    const actionButtons = [
      {
        types: ['broker'],
        statuses: ['pending'],
        permissions: ['broker.approve'],
        button: (
          <Button
            className="pull-right"
            label="Activate"
            bsStyle="secondary"
            rightIcon="check"
            isLoading={isActivating}
            handleClick={activateBroker}
          />
        ),
      },

      {
        types: ['broker'],
        permissions: ['broker.edit'],
        button: (
          <Button
            label={'Edit Broker'}
            link
            to={'/admin/brokers/' + brokerId + '/edit'}
            className="pull-right"
            bsStyle="primary"
            rightIcon="pencil-square-o"
          />
        ),
      },
      {
        types: ['broker'],
        permissions: ['broker.edit'],
        button: (
          <TransferBrokerButton
            className="pull-right"
            label="Merge Agencies"
            resource={resource}
            resourceType={'brokers'}
          />
        ),
      },

      {
        types: ['broker'],
        statuses: ['active'],
        permissions: ['broker.deactivate'],
        button: (
          <Button
            className="pull-right"
            label="Deactivate"
            bsStyle="primary"
            rightIcon="ban"
            isLoading={isDeactivating}
            handleClick={deactivateBroker}
          />
        ),
      },
      {
        types: ['broker'],
        statuses: ['inactive'],
        permissions: ['broker.deactivate'],
        button: (
          <Button
            className="pull-right"
            label="Reactivate"
            bsStyle="primary"
            rightIcon="check"
            isLoading={isReactivating}
            handleClick={reactivateBroker}
          />
        ),
      },
      {
        types: ['broker'],
        permissions: ['organisation.view'],
        button: (
          <Button
            link
            className="pull-right"
            to={'/admin/organisations/' + organisation.data.id}
            bsStyle="primary"
            label="View organisation"
          />
        ),
      },
    ];

    return actionButtons.filter((button) => {
      if (button.types.indexOf(brokerType) === -1) {
        return false;
      }

      return !(button.statuses && button.statuses.indexOf(status) === -1);
    });
  };

  const organisation = getIncludedResource(
    resource.data,
    resource.included,
    'organisation',
  );
  const organisationAccessChannels = getIncludedResource(
    resource.data,
    resource.included,
    'organisation_channel_access',
  );

  const resourceAttributes = resource.data.attributes;

  const address = displayAddress(resourceAttributes.address);
  const source = getIncludedResource(resource.data, resource.included, 'sources');
  return (
    <Box>
      <>
        <Row>
          <Col sm={6}>
            <InfoLabel
              label="Trading Name"
              value={resourceAttributes.trading_name}
              labelSize={4}
            />
          </Col>
          <Col sm={6}>
            <InfoLabel
              label="Branch Name"
              value={resourceAttributes.branch_name}
              labelSize={4}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <InfoLabel
              label="Reference"
              value={get(resourceAttributes, 'reference', '')}
              labelSize={4}
            />
          </Col>
          <Col sm={6}>
            <InfoLabel
              label="Sources"
              value={
                source.length > 0
                  ? source.reduce(
                      (carry, source) =>
                        (carry ? carry + ', ' : '') + source.attributes.name,
                      '',
                    )
                  : ''
              }
              labelSize={4}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <InfoLabel
              label="Phone Number"
              value={resourceAttributes.phone_number}
              labelSize={4}
            />
          </Col>
          <Col sm={6}>
            <InfoLabel
              label="Hold Client Money"
              value={resourceAttributes.hold_client_money ? 'Yes' : 'No'}
              labelSize={4}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <InfoLabel label="Address" value={address} labelSize={4} />
          </Col>
          <Col sm={6}>
            <InfoLabel
              label="Can Transact"
              value={resourceAttributes.can_transact ? 'Yes' : 'No'}
              labelSize={4}
            />
          </Col>
        </Row>

        <Row>
          <Col sm={6}>
            <InfoLabel
              label="Renewals Enabled"
              value={resourceAttributes.metadata?.renewals_enabled ? 'Yes' : 'No'}
              labelSize={4}
              infoButton={
                <InfoButton
                  content={
                    'This simply determines whether customer renewal correspondence is sent from the system – renewals will still be generated and associated documentation will be available for the Broker to use as they require.'
                  }
                />
              }
            />

            <InfoLabel
              label="Can use data for marketing"
              value={resourceAttributes.metadata?.allow_marketing ? 'Yes' : 'No'}
              labelSize={4}
            />

            <InfoLabel
              label="Organisation Channel Access"
              value={
                Array.isArray(organisationAccessChannels)
                  ? organisationAccessChannels
                      ?.map((channel) => channel?.attributes?.name)
                      .join(', ')
                  : ''
              }
              labelSize={4}
            />
          </Col>
        </Row>
      </>

      <>
        <hr />
        <Row>
          <Col sm={6}>
            <InfoLabel
              label="Organisation Name"
              value={get(organisation, 'data.attributes.name')}
              labelSize={4}
            />
          </Col>
          <Col sm={6}>
            <InfoLabel
              label="FCA Number"
              // value={get(organisation, 'data.attributes.regulatory_authority_number')}
              value={get(organisation, 'data.attributes.legal_entity_number')}
              labelSize={4}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <InfoLabel
              label="Phone Number"
              value={get(organisation, 'data.attributes.phone1')}
              labelSize={4}
            />
          </Col>
          <Col sm={6}>
            <InfoLabel
              label="Company Number"
              // value={get(organisation, 'data.attributes.legal_entity_number')}
              value={resourceAttributes.metadata?.company_registration_number}
              labelSize={4}
            />
          </Col>
        </Row>
      </>

      <Row>
        <hr />
        <Col sm={6}>
          <InfoLabel
            label="Status"
            value={displayName(
              brokerStatuses[get(resourceAttributes, 'status', 'applied')],
            )}
            labelSize={4}
          />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <InfoLabel
            label="Created At"
            date={true}
            value={resourceAttributes.created_at}
            labelSize={4}
          />
        </Col>
        <Col sm={6}>
          <InfoLabel
            label="Updated At"
            date={true}
            value={resourceAttributes.updated_at}
            labelSize={4}
          />
        </Col>
      </Row>

      <div className="hr transparent" />
      <Row>
        <Col sm={12}>
          <InternalButtonBar buttons={buttons()} />
        </Col>
      </Row>
    </Box>
  );
};

export default connect(
  (state) => ({
    broker: state.broker,
  }),
  {
    onDeactivateBroker: actions.deactivateBroker,
    onReactivateBroker: actions.reactivateBroker,
    onActivateBroker: actions.activateBroker,
  },
)(BrokerShow);
